import ApiResources from '../../helpers/APIResource';
import API, { toHardLink } from '../app.api';

export const getFolderArchitecture = async () => {
    const res = await API.get(
        `/api/v1/module/drive/client-folder/architecture`
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const getFolderNode = async (folderId, depth) => {
    const res = await API.get(
        `/api/v1/module/drive/client-folder/inode?depth=${depth}&parentId=${folderId}`
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const searchFile = async (query) => {
    const res = await API.get(
        `/api/v1/module/drive/client-folder/inode-file/search?filename=${query}`
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const createFolder = async (parentId, name) => {
    const res = await API.post(
        `/api/v1/module/drive/client-folder/inode-folder`,
        {
            parentId,
            name,
        }
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const deleteElement = async (id) => {
    const res = await API.delete(
        `/api/v1/module/drive/client-folder/inode?ids=${id}`
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const editElement = async (id, name) => {
    const res = await API.put(
        `/api/v1/module/drive/client-folder/inode/${id}`,
        {
            name,
        }
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const importElements = async (formData) => {
    const res = await API.post(
        `/api/v1/module/drive/client-folder/inode-file`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const moveElement = async (customerId, elementId, parentId) => {
    const res = await API.put(`/api/v1/module/drive/client-folder/inode/move`, {
        inodeIds: [elementId],
        destinationInodeId: parentId,
    });

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const getFilePreview = (customerId, fileId) => {
    return toHardLink(`/api/v1/module/drive/file/${fileId}/download`);
};

export const getFileDownload = (customerId, fileId) => {
    return toHardLink(`/api/v1/module/drive/file/${fileId}/download`);
};

export const getFolderDownload = () => {
    return toHardLink(`/api/v1/module/drive/folder/download`);
};

export const getBulkDownload = (customerId) => {
    return toHardLink(`/api/v1/module/drive/inode/download`);
};

export const getFileInformation = async (fileId) => {
    const res = await API.get(
        `/api/v1/module/drive/file/${fileId}/information`
    );

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const postFileComment = async (fileId, comment) => {
    const res = await API.post(`/api/v1/module/drive/file/${fileId}/comment`, {
        text: comment,
    });

    ApiResources.hydrateResource(res.data);

    return res.data;
};

export const getMultipleFilesDownload = () => {
    return toHardLink(`/api/v1/module/drive/file/download`);
};
